/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/ControlFocusManager',[], function () {
    "use strict";


    var ControlFocusManager = function () {
        this.initControlFocusManager();
    };

    ControlFocusManager.prototype.initControlFocusManager = function () {
        this._controlList = [];
        this._currentControlIndex = -1;
        this.currentFocusGroup = null;
        this.focusConstraints = null;
    };

    ControlFocusManager.prototype.getCurrentControl = function () {
        if (this._currentControlIndex >= 0 && this._currentControlIndex < this._controlList.length) {
            return this._controlList[this._currentControlIndex].control;
        }
        return null;
    };

    ControlFocusManager.prototype.setFocusConstraints = function(constraints) {
        this.focusConstraints = constraints;
    }

    ControlFocusManager.prototype.removeFocusConstraints = function() {
        this.focusConstraints = null;
    }

    ControlFocusManager.prototype.addControl = function (control, active, focusGroup, index) {
        this._controlList.push({control: control, active: active, focusGroup: focusGroup, index: index});
    };

    ControlFocusManager.prototype.removeAllControls = function () {
        for (var i = 0; i < this._controlList.length; i++) {
            this._controlList[i].control.focus = false;
            this._controlList[i].control.active = false;
        }
        this._controlList = [];
        this._currentControlIndex = -1;
        this.currentFocusGroup = null;
    };

    ControlFocusManager.prototype.removeControls = function (controlName) {
        this._controlList = this._controlList.filter(function (c, i) {
            return c.focusGroup !== controlName;
        }.bind(this));
    };

    ControlFocusManager.prototype.setControlActive = function (control, active) {
        for (var i = 0; i < this._controlList.length; i++) {
            if (this._controlList[i].control == control) {
                this._controlList[i].active = active;
                break;
            }
        }
    };

    ControlFocusManager.prototype.sortActives = function () {
        var active = this._controlList
            .filter(function (a) {
                return a.active;
            })
            .sort(function (a, b) {
                return a.index - b.index;
            });
        var inactive = this._controlList.filter(function (a) {
            return !a.active;
        });
        this._controlList = active.concat(inactive);
    };

    ControlFocusManager.prototype.setFocusGroup = function (focusGroup) {
        if (this.currentFocusGroup != focusGroup) {
            this.currentFocusGroup = focusGroup;
            for (var i = 0; i < this._controlList.length; i++) {
                if (this._controlList[i].focusGroup == focusGroup) {
                    this._controlList[i].active = true;
                } else {
                    this._controlList[i].active = false;
                }
            }
            this.focusNextControl(1, true);
        }
    };

    ControlFocusManager.prototype.nextFocusGroup = function () {
        let noFocusSelected = !!(!this.currentFocusGroup || this._currentControlIndex < 0);
        if (this.focusConstraints) {
            if (noFocusSelected) {
                this.setFocusGroup(this.focusConstraints[0]);
            } else {
                let currentIndex = this.focusConstraints.indexOf(this.currentFocusGroup);
                currentIndex++;
                currentIndex = currentIndex < this.focusConstraints.length ? currentIndex : 0;
                this.setFocusGroup(this.focusConstraints[currentIndex]);
            }
        } else {
            if (noFocusSelected) {
                this.setFocusGroup(this._controlList[0].focusGroup);
            } else {
                for (var i = this._currentControlIndex; i < this._controlList.length; i++) {
                    if (this._controlList[i].focusGroup !== this.currentFocusGroup) {
                        this.setFocusGroup(this._controlList[i].focusGroup, true);
                        break;
                    }
                }
            }
        }
    };

    ControlFocusManager.prototype.prevFocusGroup = function () {
        if (!this.currentFocusGroup || this._currentControlIndex < 0) {
            this.setFocusGroup(this._controlList[0].focusGroup);
            //this.focusNextControl(1);
        } else {
            for (var i = this._currentControlIndex; i >= 0; i--) {
                if (this._controlList[i].focusGroup != this.currentFocusGroup) {
                    this.setFocusGroup(this._controlList[i].focusGroup);
                    //this.focusNextControl(-1);
                    break;
                }
            }
        }

    };

    ControlFocusManager.prototype.focusNextControl = function (dir, isTab) {
        var start = dir === 1 ? this._controlList.length - 1 : 0;
        var isLastTile;

        var lastActiveIndex;

        for (var i = 0; i < this._controlList.length; i++) {
            if (this._controlList[i].active)
                lastActiveIndex = i;
        }

        if (this._currentControlIndex >= 0 && this._currentControlIndex < this._controlList.length) {
            start = this._currentControlIndex;
            this._controlList[this._currentControlIndex].control.focus = false;
        }

        do {
            this._currentControlIndex = (this._currentControlIndex + dir);

            if (!isTab && (!this._controlList[this._currentControlIndex] ||
                (this._controlList[this._currentControlIndex] && !this._controlList[this._currentControlIndex].active) &&
                this._currentControlIndex >= lastActiveIndex)
            ) {
                isLastTile = true;
                this._currentControlIndex -= dir;
                break;
            }
            if (this._currentControlIndex < 0) {
                this._currentControlIndex = this._controlList.length - 1;
            } else if (this._currentControlIndex > this._controlList.length - 1) {
                this._currentControlIndex = 0;
            }
            if (this._currentControlIndex === start) {
                break;
            }
        }
        while (!this._controlList[this._currentControlIndex].active);

        var currentControl = this._controlList[this._currentControlIndex];

        if (currentControl && currentControl.active) {
            currentControl.control.focus = true;
            this.currentFocusGroup = currentControl.focusGroup;
        }
        return isLastTile;
    };

    ControlFocusManager.prototype.activateCurrentControl = function () {
        if (this._currentControlIndex >= 0 && this._controlList[this._currentControlIndex].control.handleActivate) {
            //this._controlList[this._currentControlIndex].control.focus = false;
            this._controlList[this._currentControlIndex].control.handleActivate();
        }
    };

    ControlFocusManager.prototype.unfocusCurrentControl = function () {
        if (this._currentControlIndex >= 0) {
            this._controlList[this._currentControlIndex].control.focus = false;
            this._currentControlIndex = -1;
        }
    };

    ControlFocusManager.prototype.focusCurrentControl = function () {
        if (this._currentControlIndex === -1) {
            this._currentControlIndex = 0;
            this._controlList[this._currentControlIndex].control.focus = true;
        }
    };

    ControlFocusManager.prototype.setFocusOnCurrentTile = function (isDown) {
        this._controlList[this._currentControlIndex].control.focus = false;
        if (isDown) {
            for (var i = this._controlList.length - 1; i >= 0; i--) {
                if (this._controlList[i].focusGroup === this.currentFocusGroup) {
                    this._currentControlIndex = i;
                    if (this._controlList[this._currentControlIndex].active) {
                        break;
                    }
                }
            }
        } else {
            for (var i = 0; i <= this._controlList.length - 1; i++) {
                if (this._controlList[i].focusGroup === this.currentFocusGroup) {
                    this._currentControlIndex = i;
                    if (this._controlList[this._currentControlIndex].active) {
                        break;
                    }
                }
            }
        }
        this._controlList[this._currentControlIndex].control.focus = true;
        this.currentFocusGroup = this._controlList[this._currentControlIndex].focusGroup;

    };

    ControlFocusManager.prototype.getLastControl = function () {
        return this._controlList[this._controlList.length - 1];
    };

    ControlFocusManager.prototype.getFirstControl = function () {
        return this._controlList[0];
    };

    return ControlFocusManager;

});

